import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { ApplyFilter } from '@app/+catalog/store';

/**
 * When the user applies a filter to a product list.
 */
const events = getEvents(({ payload: { filterItem, filterOptions } }: ApplyFilter) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'applyFilter',
      filterType: getFilterType(filterOptions),
      filterValue: getFilterValue(filterItem, filterOptions)
    }
  }
]);

function getFilterType(options) {
  return options.facet.toString().split('.')[0];
}

function getFilterValue(item, options) {
  const filterType = getFilterType(options);
  let filterValue = '';
  switch (filterType) {
    case 'price':
      const { min, max } = item;
      let minFilterValue = min !== '' ? `min:${min}${options.currency}` : '';
      const maxFilterValue = max !== '' ? `max:${max}${options.currency}` : '';
      minFilterValue = minFilterValue !== '' && maxFilterValue !== '' ? minFilterValue + '-' : minFilterValue;
      filterValue = minFilterValue + maxFilterValue;
      return filterValue;
    case 'stock':
      return '1';
    case 'sold':
      return item.value;
    default:
      filterValue = item.id ? item.id + '_' : '';
      return filterValue + item.label;
  }
}

export default events;
